/* polyfill older browsers */
import 'babel-polyfill';
import 'intersection-observer';

import User from './user';
window.User = User;

/* Vue setup */
import Vue from 'vue';

/* Require custom components (takes files like MyComponent and creates component aliases of my-component) */
const components = require.context('./components', true, /\.vue$/i);
components.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], components(key).default));

/* Setup axios */
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
Vue.prototype.$http = axios;

import outsideClick from './directives/click-outside';
Vue.directive('outside-click', outsideClick);

/* Setup store */
import store from './store';

/* Setup Router */
import router from './router';

/* Require helpers, alias methods onto vue prototype */
const helpers = require.context('./helpers', true, /\.js$/i);
helpers.keys().forEach((key) => {
    const helper = helpers(key).default;
    Object.keys(helper).forEach((method) => {
        if(method[0] === '_') {
            Vue.prototype[method] = helper[method];
        } else {
            Vue.prototype['$' + method] = helper[method];
        }
    }); 
});

import App from './components/App';

/* Vue instance */
const app = new Vue({
    store: store,
    router: router,
    render: h => h(App)
});

app.$store.state.webp = window.webp;
app.$store.state.user = new User(window.user);

app.$mount('#app');

app.$store.state.screenWidth = window.innerWidth;
app.$store.state.updateBodyHeight();
window.addEventListener('resize', function (event) {
    app.$store.state.screenWidth = window.innerWidth;
    app.$store.state.updateBodyHeight();
});